import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import About from "./About";
import ViewCompanyDetailsHeader from "./ViewClientDetailsHeader";

export default function ViewWordDetails() {
  const location = useLocation();
  const navigate = useNavigate();
  const clientData = location?.state?.clientData;
  const [step, setStep] = useState(1);

  const handleStepChange = (newStep) => setStep(newStep);

  const renderStep = () => {
    switch (step) {
      case 1:
        return (
          <>
            <About clientData={clientData} />
          </>
        );
      case 2:
        return <>{/* Add Step 2 content here */}</>;
      case 3:
        return <>{/* Add Step 3 content here */}</>;
      case 4:
        return <>{/* Add Step 4 content here */}</>;
      default:
        return null;
    }
  };

  return (
    <>
      <div className="content">
        <div className="container-fluid">
        <div className="d-flex justify-content-lg-start">
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => navigate(-1)}
                >
                  <i className="bi bi-arrow-left"></i>
                </button>
              </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="card mt-5 position-relative">
                {/* Edit Button */}
                <button
                  type="button"
                  className="btn btn-soft-danger position-absolute"
                  style={{ top: "10px", right: "10px" }}
                  onClick={() =>
                    navigate(`/manage_word/edit_word`, {
                      state: { clientData },
                    })
                  }
                >
                  <i className="ri-settings-2-line align-text-bottom me-1 fs-16 lh-1"></i>
                  Edit Word
                </button>

                <div className="row align-items-center p-4">
                  {/* Profile Image */}
                  <div className="col-6 text-center">
                    <img
                      src={clientData?.logo || "/path/to/default-logo.png"}
                      alt="Logo"
                      className="avatar-lg rounded-circle mb-3"
                    />
                    <p>Logo</p>
                  </div>

                  {/* Letter Image */}
                  <div className="col-6 text-center">
                    <img
                      src={clientData?.latter_image || "/path/to/default-logo.png"}
                      alt="Letter"
                      className="avatar-lg rounded-circle mb-3"
                    />
                    <p>Letter Image</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Profile Details */}
          <div className="row mt-4">
            <div className="col-sm-12">
              <div className="card p-4">
                <div className="card-body">
                  <div className="profile-content">
                    <h5>Letter Information</h5>
                    <div className="row">
                      <div className="col-md-4">
                        <p>
                          <strong>Is Free:</strong> {clientData?.is_free ? "Yes" : "No"}
                        </p>
                      </div>
                      <div className="col-md-4">
                        <p>
                          <strong>Points:</strong> {clientData?.points || "N/A"}
                        </p>
                      </div>
                      <div className="col-md-4">
                        <p>
                          <strong>Status:</strong> {clientData?.status || "N/A"}
                        </p>
                      </div>
                    </div>

                    {/* Tabs for different sections */}
                    {/* <ViewCompanyDetailsHeader step={step} onStepChange={handleStepChange} /> */}

                    {/* Step Content */}
                    {/* <div className="tab-content mt-4">
                      {renderStep()}
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
